import { render, staticRenderFns } from "./content.vue?vue&type=template&id=6ec25e8b&scoped=true"
import script from "./content.vue?vue&type=script&lang=ts"
export * from "./content.vue?vue&type=script&lang=ts"
import style0 from "./content.vue?vue&type=style&index=0&id=6ec25e8b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec25e8b",
  null
  
)

export default component.exports